import type { ThunkDispatch } from '@ms/yammer-data/dist/types';

import type { YammerWebState } from '../../../../state/types';

export const lazyPreloadPageData = async (
  dispatch: ThunkDispatch<YammerWebState>,
  getState: () => YammerWebState
): Promise<void> => {
  const module = await import(/* webpackChunkName: "4-feat-preload-page-data" */ './preloadPageData');

  module.preloadPageData(dispatch, getState);
};

export const lazyLoadBootstrapDismissablePrompts = async (dispatch: ThunkDispatch<YammerWebState>): Promise<void> => {
  const module = await import(
    /* webpackChunkName: "4-feat-bootstrap-dismissable-prompts" */ './loadBootstrapDismissablePrompts'
  );

  module.loadBootstrapDismissablePrompts(dispatch);
};

export const lazyLoadBootstrapNetworkTopicSettings = async (
  dispatch: ThunkDispatch<YammerWebState>,
  getState: () => YammerWebState
): Promise<void> => {
  const module = await import(
    /* webpackChunkName: "4-feat-bootstrap-network-topic-settings" */ './loadBootstrapNetworkTopicSettings'
  );

  module.loadBootstrapNetworkTopicSettings(dispatch, getState);
};

export const lazyPreloadNavigationGroups = async (dispatch: ThunkDispatch<YammerWebState>): Promise<void> => {
  const module = await import(/* webpackChunkName: "4-feat-preload-navigation-groups" */ './preloadNavigationGroups');

  module.preloadNavigationGroups(dispatch);
};

export const lazyPreloadBroadcastEvent = async (dispatch: ThunkDispatch<YammerWebState>): Promise<void> => {
  const module = await import(/* webpackChunkName: "4-feat-preload-broadcast-event" */ './preloadBroadcastEvent');

  module.preloadBroadcastEvent(dispatch);
};
